import { useState } from 'react'
import { StockAlertInitialState, StockAdjustmentInfo } from '../initial_states/stockAlert'

function StockAlertProvider(): StockAlertInitialState {
  const [stockAdjusted, setStockAdjusted] = useState<StockAdjustmentInfo>({
    adjusted: false,
    reason: null,
    productName: '',
    originalQuantity: 0,
    newQuantity: 0,
  })

  return {
    stockAdjusted,
    setStockAdjusted,
  }
}

export default StockAlertProvider
